import { cornType, makeCorn } from '@eigtech/shared-corn';
export const serviceName = 'estimates';
export const estimatesServiceCorn = (eventName) => cornType(serviceName, eventName);
export const EstimatesServiceCornSchema = estimatesServiceCorn();
// #region Estimate Corn
export const EstimateCornSchema = estimatesServiceCorn('estimate');
export const isEstimateCorn = (entityId) => EstimateCornSchema.safeParse(entityId).success;
export const makeEstimateCorn = (id) => makeCorn({ serviceName, resourceType: 'estimate', resourceId: id });
// #endregion Estimate Corn
// #region Line Item Corn
export const LineItemCornSchema = estimatesServiceCorn('lineItem');
export const isLineItemCorn = (entityId) => LineItemCornSchema.safeParse(entityId).success;
export const makeLineItemCorn = (id) => makeCorn({ serviceName, resourceType: 'lineItem', resourceId: id });
// #endregion Line Item Corn
